module.exports = __webpack_public_path__ + "static/media/c.00f2c430.jpg";